import { useCallback } from 'react';
import { customDeviceList } from './customDeviceList';
import { usePostMessage } from '../context/messageContext';

export const getDimensionsFromFormula = (diagonalMm, aspectRatio) => {
  const width = Math.round(diagonalMm / Math.sqrt(Math.pow(aspectRatio, 2) + 1));
  const height = Math.round(aspectRatio * width);
  return { width, height };
};

const lookupLocal = (makeName, modelName) => {
  const selectedDeviceId = `${makeName.toLowerCase()}-${modelName.replace(/\s+/g, '-').toLowerCase()}`;
  const modelList = customDeviceList.find((device) => device.make === makeName)?.models || [];
  const deviceModel = modelList.find((model) => model.id === selectedDeviceId || model.name === modelName);
  return deviceModel ? getDimensionsFromFormula(deviceModel.diagonalMm, deviceModel.aspectRatio) : null;
};

// Sends the selected device's screen size to the clinician as `rulerDimensions` (same message and
// maths as a ruler measurement), then `changeLegacyViewToRulerDimensions`.
// sendDeviceDimensions(make, model, dims?) - `dims` ({width, height} in mm, width = long edge) comes
// from the API catalogue; without it the model is looked up in customDeviceList. Returns the
// dimensions that were sent (or null). The content also carries `device: {make, model}` so the
// clinician can show the device name (C3.2).
export const useCustomDeviceDimensions = () => {
  const postMessage = usePostMessage();

  return useCallback(
    (make, model, dims) => {
      const size = dims?.width && dims?.height ? { width: dims.width, height: dims.height } : lookupLocal(make, model);
      if (!size?.width || !size?.height) return null;
      postMessage?.({
        type: 'rulerDimensions',
        content: {
          rulerWidth: size.width,
          rulerHeight: size.height,
          screenWidthPx: window.innerWidth,
          screenHeightPx: window.screen.height,
          device: { make, model },
        },
      });
      postMessage?.({ type: 'changeLegacyViewToRulerDimensions' });
      return size;
    },
    [postMessage],
  );
};
